import React, { useState } from 'react';
import { Box, Card, CardContent, CardMedia, Collapse, Grid, IconButton, TextField, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch } from 'react-redux';
import { deletePlayer } from '../../../../../actions/players.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { confirmActionNotification } from '../../../../../actions/notifications.js';
import { useNotifications } from '../../../../../v2/notifications/NotificationManager.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faUser, faTrashCan, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import DsasButton from '../../../../components/DsasButton/DsasButton.js';
import { Can } from '../../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../../permissions/permissionKeys.js';
import { ExportButton } from '../../../../components/Dialog/ExportButton.js';

const PlayerCard = ({ player, actions, removePlayerFromList, className="", showExport=true, showPicture=true }) => {
  const [expandedTeamHistory, setExpandedTeamHistory] = useState(false);
  const [expandedPlayerInfo, setExpandedPlayerInfo] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {addNotification} = useNotifications()

  const handleExpandClick = (type) => {
    if (type==='team-history'){
      setExpandedTeamHistory(!expandedTeamHistory);
    }
    if (type==='player-info'){
      setExpandedPlayerInfo(!expandedPlayerInfo);
    }
    
  };

  const handleEditClick = () => {
    const currentURL = `${location.pathname}${location.search}`; // Inclut les paramètres

    navigate(`/sports/players/create/${player._id}`, { state: { from: currentURL } });
  };

  const handleMultiEditClick = () => {
    const currentURL = `${location.pathname}${location.search}`; // Inclut les paramètres
    navigate(`/sports/players/thirdparty/${player.thirdPartyId}/${player.thirdPartyEntityId}`, { state: { from: currentURL } });
  };

const rawURL = `dsas-view/joueur/${player.lastname}_${player._id}`

const getCurrentTeamName = (player) => {

  let currentTeam = undefined;

    if (player.teams && player.teams.length) {
      currentTeam = player.teams[0].name;
    }

    if (!currentTeam && player.teamsSeason && player.teamsSeason.length) {
      player.teamsSeason.forEach((team) => {
        if (team.endDate === null && team.name) {
          currentTeam = team.name;
      }
    })
  }
    return currentTeam || 'Aucun';
   
  }

  return (
    <Card className={className}>
      {/*SECTION HEADER*/}
      <Box className='padding-wrapper cardHeader'>
      <Typography className='cardTitle'>
          {player.lastname}
        </Typography>
        <Typography className='cardSubtitle'>
          {player.firstname}
        </Typography>
        <Typography className='cardSubtitle'>

        {`Club actuel: ${getCurrentTeamName(player)}`}
        </Typography>
      </Box> 
      <Box className='large-separator'></Box>

      {/*SECTION PHOTO + EXPORT*/}
      <Box className='padding-wrapper'>
        <Grid container spacing={1.5}>
        {showPicture && <Grid item xs={showExport ? 6 : 12} sm={showExport ? 6 : 12} md={showExport ? 6 : 12} className='userAvatarWrapper'>
          {/* Image*/}
          {player?.photoUrl && <CardMedia
            className='userAvatar'
            component="img"
            image={player.photoUrl}
            alt={`${player.lastname} ${player.firstname}`}
          />}
          {!player.photoUrl && 
          <Box className='userAvatar'>
            <FontAwesomeIcon icon={faUser} />
          </Box>
          }
          {/* </Box> */}
          </Grid>}
          {showExport &&
          <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_PROFILE}>
            <Grid item xs={showPicture ? 6 : 12} sm={showPicture ? 6 : 12} md={showPicture ? 6 : 12}>
            <Box sx={{
              display: 'grid', 
            }}>
              
              {/*Export button
              <a href={`${getRawURL()}`}>
              <Box className='actionButtonIcon'>
                  <Typography>Export</Typography>
                  <FontAwesomeIcon icon={faFileExport} />
              </Box>
              </a>*/}

              <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EXPORT}>
                <ExportButton targetUrl={rawURL}/>
              </Can>
            </Box>
          </Grid>         
          </Can> 
          }
        </Grid>
      </Box>

      {/*SECTION INFOS*/}
      {/*Expandable - Historique équipes */}
      <CardContent sx={{ flex: '1 0 auto' }}>
        <Box className='display-grid'>
            <Box className='expandableMenu'>
              <Typography>Historique des équipes</Typography>
              <IconButton
                sx={{ marginLeft: 'auto' }}
                onClick={() =>handleExpandClick('team-history')}
                aria-expanded={expandedTeamHistory}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </IconButton>
            </Box>
          </Box>
          <Box className='large-separator medium-padding' sx={{width:'auto'}}></Box>
          <Collapse in={expandedTeamHistory} timeout="auto" unmountOnExit className='expandableInfos'>
            <CardContent className='large-content'>
              {player.teamsSeason && player.teamsSeason.length ? (
                player.teamsSeason.map((teamSeason, idx) => (
                  <Box key={teamSeason._id} sx={{ marginBottom: '1rem' }}>
                    {/* Nom de l'équipe */}
                    <Typography paragraph sx={{ textAlign: 'center', fontWeight: 'bold' }}> 
                      {teamSeason.name}
                    </Typography>
                    {/* Dates de début et fin */}
                    <Grid container spacing={1.5} sx={{ alignItems: 'flex-end' }}>
                      <Grid item xs={6} sm={6} md={6}>
                        <TextField
                          className="customInput"
                          fullWidth
                          label="Date de début"
                          type="date"
                          value={teamSeason.startDate ? teamSeason.startDate.split('T')[0] : ''}
                          InputLabelProps={{ shrink: true }}
                          disabled={true} 
                        />
                      </Grid>
                      
                      <Grid item xs={6} sm={6} md={6}>
                        {teamSeason.endDate ? (
                          <TextField
                            className="customInput"
                            fullWidth
                            label="Date de fin"
                            type="date"
                            value={teamSeason.endDate.split('T')[0]}
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                          />
                        ) : (
                          <TextField
                            className="customInput"
                            fullWidth
                            label="Date de fin"
                            value="--" // Affiche "--" quand pas de date de fin
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                ))
              ) : (
                <Typography paragraph sx={{ textAlign: 'center' }}>Aucune équipe</Typography>
              )}
            </CardContent>
          </Collapse>
      </CardContent>
      {expandedTeamHistory && <Box className='medium-padding large-separator'></Box>}

      {/*Expandable - Infos joueur*/}
      <CardContent sx={{ flex: '1 0 auto' }}>
        <Box className='display-grid'>
            <Box className='expandableMenu'>
              <Typography>Info joueur</Typography>
                <IconButton
                  sx={{ marginLeft: 'auto' }}
                  onClick={() => handleExpandClick('player-info')}
                  aria-expanded={expandedPlayerInfo}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </IconButton>
            </Box>
          </Box>
          <Box className='large-separator medium-padding' sx={{width:'auto'}}></Box>
        <Collapse in={expandedPlayerInfo} timeout="auto" unmountOnExit className='expandableInfos'>
            <CardContent>
              <Typography paragraph>Date de naissance: {player.birthday || 'Non spécifiée'}</Typography>
              <Typography paragraph>Taille (cm): {player.size ? `${player.size} cm` : 'Non spécifiée'}</Typography>
              <Typography paragraph>Poids (Kg): {player.weight ? `${player.weight} kg` : 'Non spécifié'}</Typography>
              <Typography paragraph>Numéro : {player.number!==null && player.number!==undefined ? player.number :'Non spécifié'}</Typography>
              <Typography paragraph>Position : {player.positioning || 'Non spécifiée'}</Typography>
              <Typography paragraph>Nationalité : {player.nationality || 'Non spécifiée'}</Typography>
            </CardContent>
        </Collapse>
      </CardContent>

      {/* <Box className='medium-padding'></Box> */}

      {/* Card Actions */}
      <Box className='large-separator'></Box>

      <Box className='cardActions'>

        {actions.length ? 
          <>
            {actions.map((action, idx) => 
            <>
              <Box className='centered-column-wrapper'>
                  <DsasButton 
                  label={action.label} 
                  onClick={() => action.onClick(player)} 
                  variant = 'secondary'
                  customCss={{ maxWidth: '110px', lineBreak: 'auto', lineHeight: '18px', borderRadius: '25px'}}
                  />
              </Box>
              {idx < actions.length - 1 && <Box className='xl-vertical-separator'></Box>}
            </>
            // <Button onClick={() => action.onClick(player)}>{action.label}</Button>
            )}
          </>
        :
        <>

        <Box className='centered-column-wrapper'>
          <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EDIT}>
            <DsasButton label='Éditer' icon={faPenToSquare} onClick={() => handleEditClick()} variant = 'secondary' />
          </Can>

          {(player.thirdPartyId && player.thirdPartyEntityId) && 
          <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_MULTIEDIT}>
            <DsasButton label='Multi-édition' icon={faPenToSquare} onClick={() => handleMultiEditClick()} variant = 'secondary' />
          </Can>
          }
        </Box>

        <Box className='xl-vertical-separator'></Box>
        

        <Box className='centered-column-wrapper'>
        <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_DELETE}>
        <DsasButton label='Supprimer' icon={faTrashCan} onClick={() => { dispatch(confirmActionNotification("Êtes-vous sûr de vouloir supprimer le joueur ?", () => {
              dispatch(deletePlayer(player._id, (id) => {removePlayerFromList(id) ; addNotification({
                title : "Suppression", 
                type : "success", 
                description : "Le joueur "+ player.lastname+" a été supprimé."
              })}))
            })) }} variant = 'secondary' />
        </Can>
        </Box>
        </>
        }
      </Box>

      
    </Card>
  );
};

export default PlayerCard;
